(function (global, Reverb) {
  Reverb = Reverb || {};
  Reverb.Offers = Reverb.Offers || {};

  const NAMESPACE = 'makeAnOffer';
  const MAKE_OFFER_ID = '#inline-make-offer';
  const TOGGLE_CLASSES = 'make-offer-open';

  Reverb.Offers.InlineOffer = (function () {
    function bindOfferCancelToggle() {
      const $icon = $('<i class="ph ph-x"></i>');

      $(document).on(`click.${NAMESPACE}`, MAKE_OFFER_ID, function () {
        const CANCEL = I18n.t('js.inlineOffer.cancel');
        const MAKE_OFFER = I18n.t('js.inlineOffer.makeAnOffer');
        const $button = $(this);

        $button.toggleClass(TOGGLE_CLASSES);
        // Remove whitespace to test for contains text
        if ($button.text().replace(/ /g, '') === CANCEL) {
          $button.empty();
          $button.text(MAKE_OFFER);
        } else {
          $button.text(CANCEL);
          // adds space before icon
          $button.prepend(' ');
          $button.prepend($icon);
        }
      });
    }

    return {
      init: bindOfferCancelToggle,
    };
  }());

  $(Reverb.Offers.InlineOffer.init);
}(window, window.Reverb));
